import { getDefaultPath } from '@iso/lib/helpers/url_sync';
import actions, { getView } from './actions';
import { isServer } from '@iso/lib/helpers/isServer';
const preKeys = getDefaultPath();

const initState = {
  collapsed: !isServer && window.innerWidth > 1220 ? false : true,
  view: !isServer && getView(window.innerWidth),
  height: !isServer && window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  categorias: [],
  totalEmpresas: 0,
  codigos: [],
  codigoVerificado: { codigo: null, verificado: false },
  cuentas: [
    { label: "Efectivo", value: "efectivo", id: 0, siigoID: 2737, codigoCuenta: 11050501, pagos: true, traslados: true },
    { label: "Davivienda", value: "davivienda", id: 1, siigoID: 2742, codigoCuenta: 11100501, pagos: true, codice: true, traslados: true  },
    { label: "Bancolombia", value: "bancolombia", id: 5, siigoID: 9002, codigoCuenta: 11100502, pagos: true, codice: true, traslados: true  },
    { label: "Credito", value: "credito", id: 6, siigoID: 2738, codigoCuenta: 13050501 },
    { label: "Caja Códice", value: "c_codice", id: 2, codigoCuenta: 11050501, pagos: true, codice: true, traslados: true  },
    { label: "Caja Tus Cupos", value: "c_cupos", id: 3, codigoCuenta: 14151, pagos: true, traslados: true  },
    { label: "CxP servicios públicos", value: "CxP servicios públicos", id: 7, codigoCuenta: 23355001, pagos: true, credito: true },
    { label: "Otras CxP", value: "Otras CxP", id: 8, codigoCuenta: 23359501, pagos: true, credito: true },
    { label: "Socios", value: "Socios", id: 4, codigoCuenta: 23550501, traslados: true  },
    { label: "Crédito proveedores", value: "Crédito proveedores", id: 9, codigoCuenta: 22050501, pagos: true, credito: true },

  ],
  tipoCompra: [
    { label: "Compra", value: 0, id: 0 },
    { label: "Gasto", value: 1, id: 1, },
    { label: "Nomina", value: 2, id: 2 },
  ],
  estadosVenta: [
    { id: 0, value: "Pendiente" },
    { id: 1, value: "En revisión" },
    { id: 2, value: "Devuelto" },
    { id: 3, value: "Aprobado" },
    { id: 4, value: "En Producción" },
    { id: 5, value: "Finalizado" },
    { id: 6, value: "Entregado" },
  ],
  tipoEgresos: [
    { label: "DIVERSOS", value: "DIVERSOS", codigoCuenta: "5195" },
    { label: "GASTOS DE PERSONAL", value: "GASTOS DE PERSONAL", codigoCuenta: "5105" },
    { label: "HONORARIOS", value: "HONORARIOS", codigoCuenta: "5110" },
    { label: "INVENTARIO DE MERCANCÍA", value: "INVENTARIO DE MERCANCÍA", codigoCuenta: "1435" },
    { label: "MANTENCION Y REPARACION", value: "MANTENCION Y REPARACION", codigoCuenta: "5145" },
    { label: "MAQUINARIA Y EQUIPO", value: "MAQUINARIA Y EQUIPO", codigoCuenta: "1520" },
    { label: "SERVICIOS", value: "SERVICIOS", codigoCuenta: "5135" }
  ],
  banners: [],
  bannerInicio: [],
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_CATEGORIAS:
    case actions.UPDATE_CATEGORIA:
      return {
        ...state,
      }
    case actions.CODIGO_VERIFICADO:
      return {
        ...state,
        codigoVerificado: action.codigoVerificado
      }
    case actions.UPDATE_INFO_BASE:
      return {
        ...state,
        categorias: action.categorias,
        totalEmpresas: action.totalEmpresas,
      }
    case actions.UPDATE_CATEGORIAS:
      return {
        ...state,
        categorias: action.categorias
      }
    case actions.UPDATE_CODIGOS:
      return {
        ...state,
        codigos: action.codigos
      }
    case actions.COLLPSE_CHANGE:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case actions.COLLPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer,
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height,
        };
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys,
      };
    case actions.CHANGE_CURRENT:
      return {
        ...state,
        current: action.current,
      };
    case actions.CLEAR_MENU:
      return {
        ...state,
        openKeys: [],
        current: [],
      };
    //BANNERS
    case actions.UPDATE_BANNERS:
      return {
        ...state,
        banners: action.banners,
        bannerInicio: action.bannerInicio || [],
      };
    case actions.DELETE_BANNER:
      const newBanners = state.banners.filter(banner => banner._id !== action.id);
      const newBannersInicio = state.bannerInicio.filter(banner => banner._id !== action.id);
      return {
        ...state,
        banners: newBanners,
        bannerInicio: newBannersInicio,
      };
    case actions.CREATE_BANNER:
      return {
        ...state,
      };
    default:
      return state;
  }
  return state;
}
